import React from 'react';
import { AccessTime } from '@material-ui/icons';
import FormConfigTime from '../../config/FormConfigTime';
import FormTimeField from '../../fields/FormTimeField';
export const FormTimeFieldPlugin = {
    icon: React.createElement(AccessTime, null),
    name: 'Time',
    type: 'Time',
    dataTypes: ['time'],
    configurator: FormConfigTime,
    element: FormTimeField
};
//# sourceMappingURL=FormTimeFieldPlugin.js.map